<!--
  ~ Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
  ~ This software is the proprietary information of Irian Software Development SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<button (click)="download()" [disabled]="!reportRef"  [label]="label" icon="ui-icon-file-download" pButton data-testid="download-btn"></button>



